import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../utils/translations';

import './MessagesContact.less';

export class MessagesContact extends React.PureComponent {
    static propTypes = {
        avatar: PropTypes.string,
        memberSince: PropTypes.string,
        ownerName: PropTypes.string,
    };

    static defaultProps = {
        translations: {},
    };

    render() {
        const {avatar, memberSince, ownerName, translations} = this.props;

        return (
            <div className="messages-contact hidden-sm hidden-md hidden-lg">
                {avatar && (
                    <div
                        className="messages-contact__avatar img-circle"
                        style={{backgroundImage: `url('${avatar}')`}}
                    />
                )}
                <div className="messages-contact__name-container">
                    {ownerName && (
                        <h2 className="messages-contact__name">{ownerName}</h2>
                    )}
                    {memberSince && (
                        <em>
                            {translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.inbox.conversation.ownerSummary.since',
                                {0: memberSince}
                            )}
                        </em>
                    )}
                </div>
            </div>
        );
    }
}
